import styled from "@emotion/styled"

const PromotionsContainer = styled.div`
    margin: 12rem;
    border-radius: 12rem;
    height: 100%;
    max-height: 200rem;
    overflow-y: auto;
    &::-webkit-scrollbar {
        height: 8px;
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }
`

const PromotionsTip = styled.div`
    font-weight: 400;
    font-size: 12rem;
    line-height: 16rem;
    margin: 12rem 0;
    color: #69728c;
`
export default function Promotions({ isLa }: { isLa?: boolean }) {
    return (
        <PromotionsContainer>
            {isLa ? (
                <PromotionsTip>
                    No Lazada Voucher Code? We offer the following top up voucher.
                </PromotionsTip>
            ) : (
                <PromotionsTip>
                    Please deposit to the wallet address below. <br />
                    The deposit will be credited to your account after 1 confirmation.
                </PromotionsTip>
            )}
        </PromotionsContainer>
    )
}
